export const UNAUTHENTICATED_STATUS_CODE = 401;
export const AUTHENTICATED_STATUS_CODE = 204;

export const TIMEOUT_EXPIRATION_IN_MINUTES = 14;
export const ACCESS_TOKEN_DURATION_IN_SECONDS = 180;
